<template>
  <Headlins />
</template>
<script>
import appConfig from '@/app.config'
import Headlins from '../../../../components/dadban/headlins/index.vue'
export default {
  page: {
    title: 'مدیریت سرفصل ها',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-headlines-courses',
  components: {
    Headlins,
  },
}
</script>
